import axios, { AxiosRequestConfig } from 'axios';
import ApiURLs from '@/ApiURLs';

class PaymentsService {
    addCreditCardInfo(data: any) {
        return axios.post(ApiURLs.addCreditCardInfo, data);
    }

    validateCardNumber(cardNumber: string) {
        return axios.get(ApiURLs.validateCardNumber,
            {
                params: {
                    cardNumber: cardNumber
                }
            });
    }

    createPaymentSession(cancelUrl: string, redirectUrl: string, paymentServiceProvider: string, products: any[], paymentMethods: any[], paymentMode: string = "payment") {
        const requestBody = {
            successUrl: redirectUrl,
            cancelUrl: cancelUrl,
            paymentServiceProvider: paymentServiceProvider,
            order: {
                products: [...products],
                paymentMethods: [...paymentMethods],
                paymentMode: paymentMode
            }
        }

        return axios.post(ApiURLs.createPaymentSession, requestBody);
    }

    getCreditCards() {
        return axios.get(ApiURLs.getCreditCards);
    }

    deleteCreditCard(id: string) {
        return axios.delete(ApiURLs.deleteCreditCard, {
            params: {
                creditCardId: id
            }
        });
    }

    getStripeConnectedAccountLink() {
        return axios.get(ApiURLs.getStripeConnectedAccountLink);
    }

    updateStripeConnectedAccountLink(data: any) {
        return axios.put(ApiURLs.updateStripeConnectedAccountLink, data);
    }

    creditCardPayment(data: any) {
        return axios.put(ApiURLs.creditCardPayment, data);
    }

    creditCardPaymentAutomatically(data: any) {
        return axios.put(ApiURLs.creditCardPaymentAutomatically, data);
    }

    createCheckoutSessionSaveCardDetails(data: any) {
        return axios.put(ApiURLs.createCheckoutSessionSaveCardDetails, data);
    }

    capture(data: any) {
        return axios.put(ApiURLs.capture, data);
    }

    cancelPayment(data: { orders: Array<any>, whoCancelled: string, typeOfOperation: string }) {
        const whoCancelled = data.whoCancelled;
        const typeOfOperation = data.typeOfOperation;

        return axios.put(ApiURLs.cancelPayment, data.orders, { params: { whoCancelled, typeOfOperation } });
    }

    getListCustomerPaymentMethods() {
        return axios.get(ApiURLs.getListCustomerPaymentMethods);
    }

    detachPaymentMethodFromCustomer(data:
        {
          connectedAccountId: string,
          paymentMethodId: string
        }
    ) {
        return axios.delete(ApiURLs.detachPaymentMethodFromCustomer,
            {
                params:
                {
                    connectedAccountId: data.connectedAccountId,
                    paymentMethodId: data.paymentMethodId,
                }
            }
        );
    }
}

export default new PaymentsService();